module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-2 col-xs-12 col-sm-12 col-md-4 col-lg-2 col-xl-2"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleModal($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-plus"
  }), _vm._v("Create new matter")])]), _vm._v(" "), _c('div', {
    staticClass: "column col-6 col-xs-12 col-sm-12 col-md-4 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Filter")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column col-4 col-xs-12 col-sm-12 col-md-4 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showArchived),
      expression: "showArchived"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showArchived) ? _vm._i(_vm.showArchived, null) > -1 : (_vm.showArchived)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showArchived,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showArchived = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showArchived = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showArchived = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "form-icon"
  }), _vm._v(" Show Archived\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('matter-table', {
    attrs: {
      "rows": _vm.matters,
      "filter": _vm.filter,
      "showArchived": _vm.showArchived
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    class: {
      active: _vm.showModal
    },
    attrs: {
      "id": "editMatter"
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "64rem"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "btn btn-clear float-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleModal($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-title h4"
  }, [_vm._v("Create a new matter")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow": "visible"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('searchClients', {
    on: {
      "selected": _vm.selectClient
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedVisatype),
      expression: "selectedVisatype"
    }],
    staticClass: "form-select",
    attrs: {
      "id": "editqtype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedVisatype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.visatypes), function(type) {
    return _c('option', {
      domProps: {
        "value": type
      }
    }, [_vm._v(_vm._s(type.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-9"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      loading: _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.makeNewMatter($event)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), (_vm.newMatterErr) ? _c('span', {
    staticClass: "label label-error"
  }, [_vm._v(_vm._s(_vm.newMatterErr))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Client")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-3"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "editqtype"
    }
  }, [_vm._v("Type")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39ee5feb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/matters.vue
// module id = 490
// module chunks = 1